import { RouteComponentProps } from "react-router";
import { BaseModel } from "sjs-base-model";

export default class MenuPathModel extends BaseModel {
    public readonly path?: string | string[] = undefined;
    public readonly component?: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any> = undefined;
    public readonly exact?: boolean = undefined;

    constructor(data: Partial<MenuPathModel>) {
        super();

        this.update(data);
    }
}
